import Alpine from "alpinejs"

Alpine.data("video", (autoplay = false) => ({
    playing: autoplay,
    init() {
        this.$nextTick(() => {
            // Set up event listeners for HTML5 video elements
            if (this.$refs.video) {
                this.$refs.video.addEventListener("play", () => {
                    this.playing = true
                })
                this.$refs.video.addEventListener("pause", () => {
                    this.playing = false
                })
            }

            // Add dialog close detection to stop videos
            const dialogElement = this.$el.closest("dialog")
            if (dialogElement) {
                dialogElement.addEventListener("close", () => {
                    this.resetVideo()
                })
            }
        })
    },
    toggle() {
        if (this.$refs.video) {
            if (this.$refs.video.paused) {
                this.$refs.video?.play()
            } else {
                this.$refs.video?.pause()
            }
        } else {
            this.playing = !this.playing
        }
    },
    resetVideo() {
        // Handle HTML5 video
        if (this.$refs.video) {
            this.$refs.video.pause()
            this.$refs.video.currentTime = 0
        }

        // Reset playing state
        this.playing = false

        // Handle iframes inside this component (if any)
        const iframes = this.$el.querySelectorAll("iframe")
        iframes.forEach((iframe) => {
            if (iframe.src) {
                // Remove the iframe src and re-add it to stop the video
                const currentSrc = iframe.src
                iframe.src = ""
                // Use setTimeout to avoid potential race conditions
                setTimeout(() => {
                    iframe.src = currentSrc
                }, 10)
            }
        })
    },
}))
